import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import React from "react";
import { ReferenceInput, SelectInput, required, useTranslate } from "react-admin";
import { useForm } from "react-final-form";

import { FormGroupGrid, GridForm, GridInput } from "../../../components/GridForm";
import { DateInput } from "../../../components/inputs";
import { RateAsPercentageInput } from "../../../components/inputs/RateAsPercentageInput";
import { SelectEnumInput } from "../../../components/inputs/SelectEnumInput";
import { TerminalSettingPerDateType } from "../../../entities/TerminalSettingPerDateType";

export const TerminalSettingPerDateForm = (props) => {
	const form = useForm();
	const translate = useTranslate();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const globalTerminalId = globalFilters?.terminal_id?.[0] || null;

	React.useEffect(() => {
		if (globalTerminalId && !form.getState().values.terminal_id) {
			form.change("terminal_id", globalTerminalId);
		}
	}, [globalTerminalId]);

	const validateDateTo = (value, allValues) => {
		const dateFrom = allValues.date_from;
		if (dateFrom && value && new Date(value) < new Date(dateFrom)) {
			return translate("osfc.messages.validation.validateDateTo");
		}
		return undefined;
	};

	return (
		<GridForm {...props}>
			<FormGroupGrid>
				<GridInput
					component={SelectEnumInput}
					source="type"
					enumName="terminal_setting_per_date_type"
					enumObj={TerminalSettingPerDateType}
					validate={[required()]}
					sm={6}
					md={2}
				/>

				<GridInput sm={6} md={2} disabled>
					<ReferenceInput source="terminal_id" reference="terminal" validate={[required()]}>
						<SelectInput optionText="name" />
					</ReferenceInput>
				</GridInput>
				<GridInput sm={6} md={3} component={DateInput} source="date_from" validate={[required()]} />
				<GridInput
					sm={6}
					md={3}
					component={DateInput}
					source="date_to"
					validate={[required(), validateDateTo]}
				/>
				<GridInput
					sm={6}
					md={2}
					component={RateAsPercentageInput}
					source="value"
					type="float"
					digitsCount={5}
					validate={[required()]}
				/>
			</FormGroupGrid>
		</GridForm>
	);
};
